/**
 * Lunch Expense module routes
 */

import { Routes, Route } from 'react-router-dom'
import LunchExpenseListPage from './pages/LunchExpenseListPage'
import LunchExpenseAdminPage from './pages/LunchExpenseAdminPage'

const LunchExpenseRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LunchExpenseListPage />} />
      <Route path="/admin" element={<LunchExpenseAdminPage />} />
    </Routes>
  )
}

export default LunchExpenseRoutes
